<div
  class="spp-pill"
  [style.color]="statusPill?.textColour ?? statusPill?.primaryColor"
  [style.background-color]="statusPill?.secondaryColor"
  [style.border-color]="statusPill?.borderColor ? statusPill?.borderColor : statusPill?.primaryColor">
  {{ statusPill?.name }}
</div>
